export const PRODUCT_REGEX = /^(cloud|db)$/;
export const VERSION_REGEX = /^v[0-9]+\.[0-9]+$/;
export const LOCALE_REGEX = /^en$/;
export const SELECT_VERSION_REGEX = /^(cloud|db)_(v[0-9]+\.[0-9])/;
export const WORD_BREAK_DELIMETER: RegExp = /([._])/g;
